import { RootState } from "redux/rootReducer";

export const selectIsDownloadingCSVAllQuestions = (state: RootState) =>
  state.downloadCSVAllQuestions.loading;
export const csvDownloadErrorMessage = (state: RootState) =>
  state.downloadCSVAllQuestions.error;
export const downloadCSVAllQuestionsResponse = (state: RootState) =>
  state.downloadCSVAllQuestions.downloadCSVAllQuestionsResponse;
